import { InstructionCounts, InstructionType } from 'app/src/engine/Instruction';
import { createContext, useContext } from 'react';

type InstructionsArchiveContext = {
	instructionCounts: InstructionCounts;
	loadInstructionCounts: (counts: InstructionCounts) => void;
	setInstructionCount: (type: InstructionType, count: number) => void;
	clearInstructionCounts: () => void;
};

const context = createContext<InstructionsArchiveContext | null>(null);

export function useInstructionsArchiveContext(): InstructionsArchiveContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error(
			'useInstructionsArchiveContext must be used within a InstructionsArchiveContextProvider',
		);
	}

	return contextValue;
}

export const InstructionsArchiveContextConsumer = context.Consumer;
export const InstructionsArchiveContextProvider = context.Provider;
